// ─────────────────────────────────────────────────────────
// Einstellungen → Layout & Textvorlagen → E-Mail Versand
// ─────────────────────────────────────────────────────────
// Standard-Betreff + Nachricht + Signatur für den Dokument-Versand per E-Mail.
// Werden verwendet, wenn beim Senden kein eigener Betreff/Text angegeben wird.
// Prefix es-. Rechte: layout:read / layout:write.
// Sprache: sichtbare Texte über t(). Die BEISPIELE in den Platzhaltern bleiben
// deutsch — sie zeigen, was beim Kunden ankommt, und der Kunde eines Schweizer
// Betriebs liest Deutsch, egal welche Sprache der Chef eingestellt hat.
import { icon, escapeHtml } from '../../utils/dom.js';
import { saveEmailSettings } from '../../core/org.js';
import { t } from '../../i18n/index.js';

// Nur die Schlüssel — Beschriftung aus settings.emailSend.ph.*
const PLACEHOLDERS = ['number', 'type', 'client', 'title', 'date'];

function defaults(s) {
  return s.emailDefaults || {};
}

export function emailSendHeadButton(ctx) {
  if (!ctx.can('layout:write')) return '';
  const saving = ctx.s.esSaving;
  return `<button class="cd-btn-primary" data-action="es-save" ${saving ? 'disabled' : ''}>${escapeHtml(saving ? t('common.saving') : t('common.save'))}</button>`;
}

export function renderEmailSendSection(ctx) {
  const { s, can } = ctx;
  if (!can('layout:read')) return `<div class="cd-set-empty">${escapeHtml(t('common.noPermission'))}</div>`;

  const v = defaults(s);
  const subject = v.subject != null ? v.subject : '{type} {number}';
  const body = v.body != null ? v.body : '';
  const signature = v.signature != null ? v.signature : '';
  const decisionNotifyTo = v.decisionNotifyTo != null ? v.decisionNotifyTo : '';
  const dis = s.esSaving || !can('layout:write') ? 'disabled' : '';
  const chips = PLACEHOLDERS.map(
    (k) => `<code class="cd-fn-chip" title="${escapeHtml(t('settings.emailSend.ph.' + k))}">${escapeHtml('{' + k + '}')}</code>`,
  ).join('');

  return `
    <div class="cd-emp">
      <div class="cd-emp-card">
        <div class="cd-emp-card-head">${icon('mail', 18)}<h3>${escapeHtml(t('settings.emailSend.title'))}</h3></div>
        <p class="cd-sc-lead">${escapeHtml(t('settings.emailSend.lead'))}</p>
        <div class="cd-dt-field">
          <label class="cd-dt-cap" for="es-subject">${escapeHtml(t('settings.emailSend.subject'))}</label>
          <input class="cd-input" id="es-subject" type="text" maxlength="200" value="${escapeHtml(subject)}" placeholder="{type} {number}" ${dis}>
        </div>
        <div class="cd-dt-field">
          <label class="cd-dt-cap" for="es-body">${escapeHtml(t('settings.emailSend.body'))}</label>
          <textarea class="cd-input cd-dt-area" id="es-body" rows="4" placeholder="${escapeHtml(t('settings.emailSend.bodyPlaceholder'))}" ${dis}>${escapeHtml(body)}</textarea>
        </div>
        <div class="cd-dt-field">
          <label class="cd-dt-cap" for="es-signature">${escapeHtml(t('settings.emailSend.signature'))}</label>
          <textarea class="cd-input cd-dt-area" id="es-signature" rows="2" placeholder="${escapeHtml(t('settings.emailSend.signaturePlaceholder'))}" ${dis}>${escapeHtml(signature)}</textarea>
        </div>
        <div class="cd-dt-field">
          <label class="cd-dt-cap" for="es-notify">${escapeHtml(t('settings.emailSend.decisionNotify'))}</label>
          <input class="cd-input" id="es-notify" type="email" maxlength="200" value="${escapeHtml(decisionNotifyTo)}" placeholder="${escapeHtml(t('settings.emailSend.decisionNotifyPlaceholder'))}" ${dis}>
          <span class="cd-sc-lead">${escapeHtml(t('settings.emailSend.decisionNotifyHint'))}</span>
        </div>
        <div class="cd-fn-ph">
          <span class="cd-nr-cap">${escapeHtml(t('settings.emailSend.placeholders'))}</span>
          <div class="cd-fn-chips">${chips}</div>
        </div>
      </div>
      <div class="cd-emp-info cd-sc-note">${icon('info', 18)}<span>${escapeHtml(t('settings.emailSend.note'))}</span></div>
    </div>`;
}

export function handleEmailSendAction(a, el, ctx) {
  const { s, draw, reload } = ctx;
  if (a !== 'es-save') return false;
  if (!ctx.can('layout:write')) return true;
  const val = (id, max) => (document.getElementById(id)?.value || '').slice(0, max);
  const payload = {
    subject: val('es-subject', 200),
    body: val('es-body', 5000),
    signature: val('es-signature', 1000),
    decisionNotifyTo: val('es-notify', 200).trim(),
  };
  s.esSaving = true; draw();
  saveEmailSettings(payload)
    .then(() => { s.esSaving = false; if (reload) reload(); else draw(); })
    .catch((err) => { s.esSaving = false; s.error = err.message || t('common.saveFailed'); draw(); });
  return true;
}
